<template>
  <v-app id="inspire" dark class="pa-0">
    <template v-if="this.$store.state.user != null">
      <v-content fill-height>
        <menu-meta
          :menudata="menudata"
          :profile="profile"
          v-if="this.$store.state.user != null && this.$route.query.pop != 1"
        ></menu-meta>
        <page-header
          :menudata="menudata"
          :profile="profile"
          v-if="this.$store.state.user != null && this.$route.query.pop != 1"
        />
        <transition fill-height name="fab-transition">
          <router-view></router-view>
        </transition>
      </v-content>
    </template>

    <v-content v-else fill-height class="ma-0 pa-0">
      <v-container fluid fill-height class="ma-0 pa-0">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
const MenuMeta = global.reqClass.requirecmpmix("@/admin/elements/inc/menu");
const PageHeader = global.reqClass.requirecmpmix(
  "@/admin/elements/inc/header.vue"
);

try {
  var Features = require("@/classes/metadmin/features").default;
} catch (err) {
  var Features = require("@/framework/classes/metadmin/features").default;
}

global.features = new Features();

export default {
  data: () => ({
    menudata: {
      drawer: null,
      items: null,
    },
    profile: null,
  }),

  async beforeMount() {
    if (this.$store.state.user) {
      this.profile = await global.features.loadProfile(this.$store);
      this.menudata.items = global.features.createMenu();
    }
  },

  components: {
    MenuMeta,
    PageHeader,
  },

  watch: {
    "$store.state.user.id": {
      async handler() {
        console.log("MUDOU USER");
        if (this.$store.state.user) {
          global.features = new Features();
          this.profile = await global.features.loadProfile(this.$store);
          this.menudata.items = global.features.createMenu();
        }
      },
    },
  },
};
</script>

<style></style>
